import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CancelIcon, SaveIcon } from "../../../common/icons";
import { useEffect, useState } from "react";
import { IValueListLight } from "../../../../types/valuelist";
import { IIndividual } from "../../../../types/individual";
import Button from "../../../common/button";
import Select from "../../../common/select/select";

type Props = {
    isOpen: boolean,
    toggle: () => void,
    indi:IIndividual|undefined,
    updateHandler: (id:number) => void,
    posStatusReasonList: IValueListLight[]
}

const UpdateDeactivationReasonModal = (props: Props)=>{

    const {isOpen, toggle,indi, updateHandler,posStatusReasonList } = props  

    const [reasonId,setReasonId] = useState<number>(0)

    const onCancel=()=>{toggle()}

    const onUpdate=()=>{updateHandler(reasonId)}

    const onChangeReason = (event:any) => {setReasonId(event.target.value)} 
    useEffect(()=>{
        if(indi?.indStatusReason?.id){
            setReasonId(indi?.indStatusReason?.id)
        }
    },[indi])

    return (
        <Modal size="md" isOpen={isOpen} toggle={onCancel} backdrop="static" autoFocus={false}>
            <ModalHeader toggle={onCancel} tag={'h2'}>Update Deactivation Reason</ModalHeader>
            <ModalBody>  
                <div style={{display:'flex'}}>
                    <div><label htmlFor="homereason1" id="homereason1-label">Deactivation Reason:</label></div>
                    <div style={{flexGrow:'1',marginLeft:'10px'}}>
                        <Select aria-labelledby="homereason1-label" id="homereason1" value={reasonId}  onChange={onChangeReason} style={{width:'100%'}} autoFocus={true}>
                            {posStatusReasonList.map((item: IValueListLight) => <option key={item.id} value={item.id}>{item.label}</option>)}
                        </Select>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
            <Button color="primary" onClick={onUpdate} disabled={reasonId===indi?.indStatusReason?.id}>
                <SaveIcon/>
                &nbsp;Update
            </Button>
            <Button color="light " onClick={onCancel}>
                <CancelIcon/>
                &nbsp;Cancel
            </Button>
            </ModalFooter>
        </Modal>
    )

}

export default UpdateDeactivationReasonModal;